export const getProductUnitSet = (item) => {
  let unitSet = "";
  if (item["__typename"].toLowerCase() === "bundleproduct") {
    if (item.simplebundle) {
      unitSet = item?.unit_text;
      return unitSet;
    }
    unitSet = item?.unit_text;
    return unitSet;
  } else if (item["__typename"].toLowerCase() === "configurableproduct") {
    unitSet = item && item?.variants[0]?.product?.unit_text;
    return unitSet;
  } else {
    unitSet = item && item?.unit_text;
    return unitSet;
  }
};
